import { useId } from "react";

import {
  CC_CENTER_SECTION_INPUT_MAX_LENGTH,
  FULL_WIDTH_INPUT_MAX_LENGTH,
} from "@/components/AIComponents/ExportablesModal/templates/components/OrganizerDirections/OrganizerDirections.constants";
import useAdjustFontSizeToFitContent from "@/view/utils/useAdjustFontSizeToFitContent/useAdjustFontSizeToFitContent";
import { vennDiagramTextArea } from "./CompareContrastOrganizer.styles";

interface OrganizerCircleTextAreaProps {
  section: "left" | "right" | "center";
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isStudent: boolean;
}

const OrganizerCircleTextArea = ({
  section,
  value,
  onChange,
  isStudent,
}: OrganizerCircleTextAreaProps) => {
  const id = useId();
  const maxLength =
    section === "center"
      ? CC_CENTER_SECTION_INPUT_MAX_LENGTH
      : FULL_WIDTH_INPUT_MAX_LENGTH;
  const formattedValue = value.substring(0, maxLength);
  const formattedSection = section.charAt(0).toUpperCase() + section.slice(1);
  const ariaLabel = ` ${formattedSection} circle input`;
  const styles = vennDiagramTextArea(section, isStudent);
  const fontSizeRef = useAdjustFontSizeToFitContent([formattedValue]);

  return (
    <textarea
      id={id}
      data-qa-selector={id}
      value={formattedValue}
      maxLength={maxLength}
      onChange={onChange}
      css={styles}
      aria-label={ariaLabel}
      ref={fontSizeRef}
    />
  );
};

export default OrganizerCircleTextArea;
